var filters = [];
var _data = [];
var _data2 = [];
var players = [];
var teams = [];
var players_collections = [];
var teams_collections = [];
var team_names_2 = [];

// Define team nicknames

team_names_2['San Francisco Football'] = 'San Francisco 49ers';
team_names_2['Chicago Football'] = 'Chicago Bears';
team_names_2['Cincinnati Football'] = 'Cincinnati Bengals';
team_names_2['Buffalo Football'] = 'Buffalo Bills';
team_names_2['Denver Football'] = 'Denver Broncos';
team_names_2['Cleveland Football'] = 'Cleveland Browns';
team_names_2['Tampa Bay Football'] = 'Tampa Bay Buccaneers';
team_names_2['Arizona Football'] = 'Arizona Cardinals';
team_names_2['San Diego Football'] = 'San Diego Chargers';
team_names_2['Kansas City Football'] = 'Kansas City Chiefs';
team_names_2['Indianapolis Football'] = 'Indianapolis Colts';
team_names_2['Dallas Football'] = 'Dallas Cowboys';
team_names_2['Miami Football'] = 'Miami Dolphins';
team_names_2['Philadelphia Football'] = 'Philadelphia Eagles';
team_names_2['Atlanta Football'] = 'Atlanta Falcons';
team_names_2['New York G Football'] = 'New York Giants';
team_names_2['Jacksonville Football'] = 'Jacksonville Jaguars';
team_names_2['New York J  Football'] = 'New York Jets';
team_names_2['Detroit Football'] = 'Detroit Lions';
team_names_2['Green Bay Football'] = 'Green Bay Packers';
team_names_2['Carolina Football'] = 'Carolina Panthers';
team_names_2['New England Football'] = 'New England Patriots';
team_names_2['Oakland Football'] = 'Oakland Raiders';
team_names_2['Los Angeles Football'] = 'Los Angeles Rams';
team_names_2['Baltimore Football'] = 'Baltimore Ravens';
team_names_2['Washington DC Football'] = 'Washington Redskins';
team_names_2['New Orleans Football'] = 'New Orleans Saints';
team_names_2['Seattle Football'] = 'Seattle Seahawks';
team_names_2['Pittsburgh Football'] = 'Pittsburgh Steelers';
team_names_2['Tennessee Football'] = 'Tennessee Titans';
team_names_2['Minnesota Football'] = 'Minnesota Vikings';
team_names_2['Atlanta Baseball'] = 'Atlanta Braves';
team_names_2['Miami Baseball'] = 'Miami Marlins';
team_names_2['New York M Baseball'] = 'New York Mets';
team_names_2['Philadelphia Baseball'] = 'Philadelphia Phillies';
team_names_2['Washington DC Baseball'] = 'Washington Nationals';
team_names_2['Chicago Baseball'] = 'Chicago Cubs';
team_names_2['Cincinnati Baseball'] = 'Cincinnati Reds';
team_names_2['Milwaukee Baseball'] = 'Milwaukee Brewers';
team_names_2['Pittsburgh Baseball'] = 'Pittsburgh Pirates';
team_names_2['St. Louis Baseball'] = 'St. Louis Cardinals';
team_names_2['Arizona Baseball'] = 'Arizona Diamondbacks';
team_names_2['Colorado Baseball'] = 'Colorado Rockies';
team_names_2['Los Angeles D Baseball'] = 'Los Angeles Dodgers';
team_names_2['San Diego Baseball'] = 'San Diego Padres';
team_names_2['San Francisco Baseball'] = 'San Francisco Giants';
team_names_2['Boston Baseball'] = 'Boston Red Sox';
team_names_2['New York Y Baseball'] = 'New York Yankees';
team_names_2['Tampa Bay Baseball'] = 'Tampa Bay Rays';
team_names_2['Toronto Baseball'] = 'Toronto Blue Jays';
team_names_2['Chicago Baseball'] = 'Chicago White Sox';
team_names_2['Cleveland Baseball'] = 'Cleveland Indians';
team_names_2['Detroit Baseball'] = 'Detroit Tigers';
team_names_2['Kansas City Baseball'] = 'Kansas City Royals';
team_names_2['Minnesota Baseball'] = 'Minnesota Twins';
team_names_2['Houston Baseball'] = 'Houston Astros';
team_names_2['Los Angeles A Baseball'] = 'Los Angeles Angels of Anaheim';
team_names_2['Oakland Baseball'] = 'Oakland Athletics';
team_names_2['Seattle Baseball'] = 'Seattle Mariners';
team_names_2['Texas Baseball'] = 'Texas Rangers';
team_names_2['Carolina Hockey'] = 'Carolina Hurricanes';
team_names_2['Columbus Hockey'] = 'Columbus Blue Jackets';
team_names_2['New Jersey Hockey'] = 'New Jersey Devils';
team_names_2['New York I Hockey'] = 'New York Islanders';
team_names_2['New York R Hockey'] = 'New York Rangers';
team_names_2['Philadelphia Hockey'] = 'Philadelphia Flyers';
team_names_2['Pittsburgh Hockey'] = 'Pittsburgh Penguins';
team_names_2['Washington DC Hockey'] = 'Washington Capitals';
team_names_2['Boston Hockey'] = 'Boston Bruins';
team_names_2['Buffalo Hockey'] = 'Buffalo Sabres';
team_names_2['Detroit Hockey'] = 'Detroit Red Wings';
team_names_2['Florida Hockey'] = 'Florida Panthers';
team_names_2['Montreal Hockey'] = 'Montreal Canadiens';
team_names_2['Ottawa Hockey'] = 'Ottawa Senators';
team_names_2['Tampa Bay Hockey'] = 'Tampa Bay Lightning';
team_names_2['Toronto Hockey'] = 'Toronto Maple Leafs';
team_names_2['Chicago Hockey'] = 'Chicago Blackhawks';
team_names_2['Colorado Hockey'] = 'Colorado Avalanche';
team_names_2['Dallas Hockey'] = 'Dallas Stars';
team_names_2['Minnesota Hockey'] = 'Minnesota Wild';
team_names_2['Nashville Hockey'] = 'Nashville Predators';
team_names_2['St. Louis Hockey'] = 'St. Louis Blues';
team_names_2['Winnipeg Hockey'] = 'Winnipeg Jets';
team_names_2['Anaheim Hockey'] = 'Anaheim Ducks';
team_names_2['Arizona Hockey'] = 'Arizona Coyotes';
team_names_2['Calgary Hockey'] = 'Calgary Flames';
team_names_2['Edmonton Hockey'] = 'Edmonton Oilers';
team_names_2['Los Angeles Hockey'] = 'Los Angeles Kings';
team_names_2['San Jose Hockey'] = 'San Jose Sharks';
team_names_2['Vancouver Hockey'] = 'Vancouver Canucks';

var team_names_3 = array_flip(team_names_2);

	function doTopSearch(q){
      
      console.log('Searching...'+q);
//       if(q.indexOf('--')>-1) q = q.split('--')[0].trim();
      var handle = players_collections[q];
      
      if(!handle){ // Try with Teams...
//         console.log(q);
        s = q.replace(' &gt; ', ' > ');
      	handle = q; 
      }
      
      window.open('/collections/'+handle+'/style-mens-premium-t-shirt', '_self');
      
	}

  
  function buildTopSearchMenu(){
    
    players.sort();
    
    var $select = $('#top-search-select');
    var $select2 = $('#top-search-select-mobile');
    
    $select.append($('<option>', {text: 'Search Player Name', value: ''}));
    $select2.append($('<option>', {text: 'Search Player Name', value: ''}));
    
    for(i in players){
                                  
		var v = players[i];
// 		if(v.indexOf('|')>-1) v = v.split('|')[0].trim();
                                  
      $select.append($('<option>', {text: players[i], value: v}));
      $select2.append($('<option>', {text: players[i], value: v}));
    }


	for(i in teams){
      
      if(team_names_3[i]){
//         console.log('====> '+team_names_3[i]);
        var h = team_names_3[i] + ' <span style="display:none;">'+teams[i]+'</span>';
      }else{
        var h = teams[i];
      }
      
      var v = h.replace("'", "").replace(/\W+/g, "-").toLowerCase();
      
//       console.log('====> '+v);
      
      $select.append($('<option>', {html: h, value: v}));
//       $select2.append($('<option>', {html: h, value: v}));
      
    }

	// Craig Sager
	players_collections['Craig Sager'] = 'sagerstrong';
	$select.append($('<option>', {text: 'Craig Sager', value: 'Craig Sager'}));
	$select2.append($('<option>', {text: 'Craig Sager', value: 'Craig Sager'}));
    
    
	$select.dropdown({saveRemoteData:true ,fullTextSearch:true, allowAdditions: false, placeholder: 'Player Name', action : function(a,b){ doTopSearch(b); }});
    $select2.dropdown({fullTextSearch:true, allowAdditions: false, placeholder: 'Player Name', action : function(a){ doTopSearch(a); }});
    
    $('.ui.search.dropdown').prepend('<span class="timber-icon timber-icon-search" aria-hidden="true">');
    
    $select.show();
    
  
  }
  
  function filterData(x){
    
//     var a = x.split('/');
//     var b = a[2];
    
//     if(_data[a[0]] == null) _data[a[0]] = [];
//     if(_data[a[0]][a[1]] == null) _data[a[0]][a[1]] = [];
    
    
//     if(b.indexOf('|')>-1){
//       b = b.split('|')[0].trim();
//     }
    
//     _data[a[0]][a[1]].push(b);
    
    
    
    if(x.substr(x.length-1,1)=='.'){ // last character is a "."
    	x=x.substr(0,x.length-1);  	
    }
    
    if(players.indexOf(x)<0) players.push(x);
    players_collections[x] = x.replace("'", "").replace(/\W+/g, "-").toLowerCase();
    
//     if(a[1]=='Fantasy Life'){ // If sport is Fantasy Life, specify this in the name 
//       var k=a[2]+' | Fantasy Life';
//       players.push(a[2]+' | Fantasy Life');
//     }else if(a[1]=='Throwbacks'){ // If sport is Fantasy Life, specify this in the name 
//       var k=a[2]+' | Throwbacks';
//       players.push(a[2]+' | Throwbacks');
//     }else{
//       var k=a[2];      
//       players.push(a[2]);
//     }
    
    
//     var team_kw = processTeamKeyword([a[1], a[0]].join(' '));
    
//     if(teams.indexOf(team_kw)<0){
//       teams.push(team_kw);
//       teams_collections[team_kw] = [a[1], a[0]].join('-').replace("'", "").replace(/\W+/g, "-").toLowerCase();
//     }
    
//     players_collections[k] = [b, a[1], a[0]].join('-').replace("'", "").replace(/\W+/g, "-").toLowerCase();
    
  }

  function filterData2(x){

    if(teams.indexOf(x)<0){
      teams.push(x);
      
      var team_kw = processTeamKeyword(x);
      
      teams_collections[team_kw] = x.replace("'", "").replace(/\W+/g, "-").toLowerCase();
    
    if(teams.indexOf(team_kw)<0){
      //teams.push(team_kw);
      
    }
      
    }
    
  }



function processTeamKeyword(kw){
  
  var a = team_names_2;
  
  var b = a[kw];
  
  if(!b) b=kw;
  
  return b;
  
  
}


$(document).ready(
  function(){
  	buildTopSearchMenu();
  }
);




function array_flip( trans )
{
    var key, tmp_ar = {};

    for ( key in trans )
    {
        if ( trans.hasOwnProperty( key ) )
        {
            tmp_ar[trans[key]] = key;
        }
    }

    return tmp_ar;
}